export default "__VITE_ASSET__xYZedF$U__"